import { Box, Text, TextLink } from '@hawkins/components';

export const CalculatorDescription = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Text>
        Enter your intended camera capture specifications and aspect
        ratio in order to calculate:
      </Text>
      <ul>
        <li>
          <Text>
            The full Original Camera Footage (OCF) Resolution or
            Capture Resolution
          </Text>
        </li>
        <li>
          <Text>
            The active image area defined by the intended aspect ratio
            and safety area
          </Text>
        </li>
        <li>
          <Text>
            Indication that the chosen capture resolution is approved
            or not approved
          </Text>
        </li>
        <li>
          <Text>
            A recommended working resolution and the minimum working
            resolution
          </Text>
        </li>
      </ul>
      <Text>
        If you want to get a better understanding of the concept of
        Working Resolution, please visit the{' '}
        <TextLink
          href="https://partnerhelp.netflixstudios.com/hc/en-us/articles/4465014482323"
          target="_blank"
        >
          Netflix Partner Help Center
        </TextLink>
      </Text>
    </Box>
  );
};
